<template>
  <gg-card>
    <gg-card-text class="pa-3">
      <!-- Reverse DNS has no backend yet. The previous version fabricated PTR rows
           from server.ips and only toasted a fake "saved" — removed entirely in
           favour of an honest, accessible empty state. -->
      <div class="kvm-coming text-center py-10">
        <v-icon size="56" color="primary" class="mb-3" aria-hidden="true">mdi-dns</v-icon>
        <h2 class="kvm-coming__heading mb-2">Reverse DNS &mdash; coming soon</h2>
        <p class="kvm-coming__text mb-0 mx-auto">
          Setting the PTR record for your server's IP addresses isn't available yet. We're working on bringing it to your dashboard.
        </p>
      </div>
    </gg-card-text>
  </gg-card>
</template>

<script>
export default {
  name: 'HostingKvmRdns',
  props: {
    // Provided by KvmServiceView via <router-view :server :loading>; kept to
    // preserve the component contract even though the body is now a static state.
    server: { type: Object, default: () => ({}) },
    loading: { type: Boolean, default: false },
  },
}
</script>

<style scoped lang="scss">
@import './kvm-ui';

.kvm-coming__heading {
  font-size: 1.25rem;
  font-weight: 500;
  line-height: 1.4;
}

.kvm-coming__text {
  @include kvm-secondary-text;
  max-width: 28rem;
}
</style>
